// Common
import { ProfileActionItem } from '$common/profile-action-item'
import PermissionsIcon from '$common/icons/permissions-icon'
import { HallInvitationLinksProfileActionItem } from './components/hall-invitation-links-profile-action-item'
import { HallRemovedUsersProfileActionItem } from './components/hall-removed-users-profile-action-item'
// Helpers
import { toLocale } from '$func/text'
// logic
import {
  useGroupChangeablePermissionsCount,
  useHall,
} from '$logic/hall/react-hook'
import { openGroupMemberPermissions, openHallSubscribers } from '$logic/router'
import { MemberPermissions } from '$logic/types/subscription'
import { HallAdminsActionItem } from '$common/hall-admin-action-item'
// Localization
import { t } from '$i18n'
import { GroupIcon } from '$common/icons'

interface Props {
  isGroup: boolean
  hallId: string
  permissions: MemberPermissions
}

export function HallSettingsActions({ isGroup, hallId, permissions }: Props) {
  const { entity: hall, loading: hallLoading } = useHall(hallId)

  const {
    allowedPermissionsCount,
    permissionsCount,
    loading: hallPermissionsItemsLoading,
  } = useGroupChangeablePermissionsCount(hallId)

  return (
    <>
      {isGroup && (
        <ProfileActionItem
          Icon={<PermissionsIcon sx={{ color: 'secondary.main' }} />}
          onClick={() => openGroupMemberPermissions(hallId)}
          secondaryText={`${toLocale(allowedPermissionsCount)}/${toLocale(
            permissionsCount,
          )}`}
          secondaryTextLoading={hallPermissionsItemsLoading}
        >
          {t('profile.hall.actions.membersPermissions')}
        </ProfileActionItem>
      )}

      {permissions.inviteViaLink && (
        <HallInvitationLinksProfileActionItem hallId={hallId} />
      )}

      <ProfileActionItem
        Icon={<GroupIcon />}
        onClick={() => openHallSubscribers(hallId)}
        secondaryText={toLocale(hall?.membersCount || '')}
        secondaryTextLoading={hallLoading}
      >
        {isGroup
          ? t('profile.hall.actions.members')
          : t('profile.hall.actions.subscribers')}
      </ProfileActionItem>

      <HallAdminsActionItem hallId={hallId} />

      {permissions.banUsers && (
        <HallRemovedUsersProfileActionItem hallId={hallId} />
      )}
    </>
  )
}
